<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="37" height="16" viewBox="0 0 37 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.048 2.212 9.204 13.818h-3.16L3.66 4.557c-.145-.57-.27-.78-.71-1.02-.72-.392-1.906-.759-2.95-.987l.072-.338h5.087c.648 0 1.231.433 1.379 1.184l1.259 6.715 3.111-7.9h3.14zm12.383 7.817c.012-3.063-4.218-3.232-4.19-4.6.01-.417.405-.86 1.269-.973.428-.056 1.609-.1 2.948.52l.525-2.462A8.008 8.008 0 0 0 24.187 2c-2.955 0-5.035 1.578-5.052 3.837-.02 1.67 1.483 2.603 2.617 3.158 1.165.569 1.556.934 1.552 1.443-.009.778-.93 1.122-1.79 1.136-1.504.023-2.375-.409-3.07-.734l-.542 2.543c.698.322 1.987.603 3.324.617 3.142 0 5.196-1.558 5.206-3.971m7.803 3.79H37L34.585 2.211h-2.552a1.36 1.36 0 0 0-1.272.851l-4.486 10.755h3.14l.622-1.733h3.836l.362 1.733zm-3.336-4.113 1.574-4.358.905 4.358H30.9zm-12.58-7.494-2.472 11.606h-2.99l2.474-11.606h2.989z"
      fill="var(--base-text-color)"
      fill-rule="nonzero"
    />
  </svg>
</template>
